
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.259 10.677l2.187-1.263A19.016 19.016 0 0022.951.301l-.522 2.48c4.54.983 8.478 3.862 10.83 7.896zM31.214 30.054l1.875 1.708c3.612-3.996 5.352-9.378 4.81-14.717l-.008-.08-2.521.336a16.664 16.664 0 01-4.156 12.753zM2.623 20.619a17.889 17.889 0 01-.003-3.416l-2.504-.281a19.619 19.619 0 00-.023 3.954c.41 4.041 2.067 7.773 4.764 10.806l1.9-1.717c-2.34-2.62-3.786-5.862-4.14-9.351l.006.005zM11.24 36.349a19.078 19.078 0 009.676 1.554c2.002-.203 3.947-.694 5.777-1.518l-1.032-2.322a16.55 16.55 0 01-5 1.335 16.492 16.492 0 01-8.384-1.363l-1.043 2.32.005-.006zM2.543 9.389l2.204 1.272c2.359-4.03 6.296-6.914 10.822-7.88L15.053.297C9.817 1.387 5.26 4.707 2.543 9.39zM8.638 18h20.719L19.305 7.912 8.638 18zM16 30V18h6v12z","fill":"#fff"}})])
          )
        }
      }
    